import { render } from "./LoginControl.vue?vue&type=template&id=31490f0a"
import script from "./LoginControl.vue?vue&type=script&lang=js"
export * from "./LoginControl.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__